export default __webpack_public_path__ + "static/media/bird-and-coffee.6a7e64de.png";